import React from 'react';
import { motion } from 'framer-motion';

const families = [
  { name: 'Vasquez', origin: 'Pământ / Zürich', color: 'text-amber-400', dot: 'bg-amber-400', role: 'Scânteia' },
  { name: 'Tanaka', origin: 'Mercur / Sistemul Interior', color: 'text-orange-400', dot: 'bg-orange-400', role: 'Inginerii' },
  { name: 'Osei-Okonkwo', origin: 'Pământ / Venus / Enceladus', color: 'text-green-400', dot: 'bg-green-400', role: 'Vindecătorii' },
  { name: 'Rivera-Mwangi', origin: 'Neptun / Interstelar', color: 'text-blue-400', dot: 'bg-blue-400', role: 'Santinelele' },
];

const LineagesIntroRo = () => (
  <section className="py-20 bg-brand-dark border-t border-white/5">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-gray-300 leading-relaxed text-xl text-center mb-14"
      >
        <em>Trezirea Cuantică</em> este, în esență, o poveste despre{' '}
        <span className="text-white font-semibold">ceea ce se transmite mai departe</span>. Nu avere. Nu rang. Ci direcția pe care o indică o viață — și cum acea direcție răsună prin toți cei care urmează.
      </motion.p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {families.map((f, i) => (
          <motion.a
            key={i}
            href={`#family-ro-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            className="bg-brand-surface border border-white/5 rounded-xl p-5 text-center hover:border-white/15 transition-all cursor-pointer"
          >
            <span className={`w-3 h-3 rounded-full ${f.dot} mx-auto block mb-3`}></span>
            <p className={`font-display font-bold text-sm ${f.color} mb-1`}>Familia {f.name}</p>
            <p className="text-gray-600 text-xs">{f.role}</p>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);

export default LineagesIntroRo;